import { useEffect, useState } from "react";
import { SimplePageType } from "../../types";
import { useParams } from "react-router";
import { Loading } from "../../utils";
import { useAppState } from "../../context";
import { useSimplePage } from "./useSimplePage";

export const SimplePage = () => {
    const { slug } = useParams();
    const [page, setPage] = useState<SimplePageType | null>(null);
    const { findPage } = useSimplePage();

    useEffect(() => {
        if (!slug || page) {
            return;
        }

        findPage(slug).then(setPage);
    }, [slug]);

    return (
        <section className="section">
            <div className="inside-wrapper inside-wrapper_sm">
                {page && (
                    <>
                        <h1 className="section__title">{page.title}</h1>
                        <div className="textblock" dangerouslySetInnerHTML={{ __html: page.content || '' }}>
                        </div>
                    </>
                )}
                {!page && (
                    <Loading/>
                )}
            </div>
        </section>
    );
}

export default SimplePage; 